import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {RomanEmpireSoundConfig} from "../../RomanEmpireSoundConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {RomanEmpireGameMode} from "../../gamemode/RomanEmpireGameMode";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {RomanEmpireParsedInitData} from "../../server/data/RomanEmpireParsedInitData";
import {RomanEmpireEvents} from "../../events/RomanEmpireEvents";

export class SoundManager {

    private _shouldPlayReSpinBgMusic: boolean = false;
    private _isReSpin: boolean = false;
    private static mediumLargeWinTimeOut : any;

    private static get soundPlayer(): INolimitAudioPlayer {
        return <INolimitAudioPlayer>SlotGame.sound;
    }

    constructor() {
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.onReady());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, RomanEmpireEvents.ON_GAME_START, () => this.onGameStart());
    }

    private onInitDataParsed(data: RomanEmpireParsedInitData) {
        this._isReSpin = data.mode == RomanEmpireGameMode.GENIE_RESPIN;
        this._shouldPlayReSpinBgMusic = (this._isReSpin && data.numberOfRespinPlayed > 0);
    }

    private onGameStart() {
        if (this._shouldPlayReSpinBgMusic) {
            SoundManager.playFSIntro();
            SoundManager.playFSBackgroundMusic();
        }
    }

    private onReady() {
        if (this._isReSpin) {
            SoundManager.playSound(RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1, undefined, 0);
            SoundManager.playSound(RomanEmpireSoundConfig.instance.MEDIUM_AND_LARGE_WIN, undefined, 0);
        } else {
            SoundManager.playSound(RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1);
            SoundManager.playSound(RomanEmpireSoundConfig.instance.MEDIUM_AND_LARGE_WIN, undefined, 0);
        }

    }

    public static playSound(name: string, repeat?: number, volume?: number): void {
        this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: volume
        })
    }

    public static stopSound(name: string): void {
        this.soundPlayer.stopTrack(name);
    }

    public static fadeInMainBGSound(duration: number): void {
        this.soundPlayer.fadeTrack({
            name: RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1,
            duration: duration,
            to: 1
        });
    }

    public static fadeOutMainBGSound(duration: number): void {
        this.soundPlayer.fadeTrack({
            name: RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1,
            duration: duration,
            to: 0
        });
    }

    public static fadeSound(name: string, duration: number, to: number, from?: number): void {
        this.soundPlayer.fadeTrack({
            name: name,
            duration: duration,
            from: from,
            to: to
        });
    }

    public static playMediumAndLargeWinSound(): void {
        Logger.logDev("mediumAndLargeWin playMediumAndLargeWinSound");
        this.soundPlayer.fadeTrack({
            name: RomanEmpireSoundConfig.instance.MEDIUM_AND_LARGE_WIN,
            to: 1,
            duration: 200
        });
        if(SoundManager.mediumLargeWinTimeOut){
            clearTimeout(SoundManager.mediumLargeWinTimeOut);
        }
        SoundManager.mediumLargeWinTimeOut = setTimeout(this.fadeMediumAndLargeWinSound.bind(this), 15000);
        // TweenLite.killDelayedCallsTo(this.fadeMediumAndLargeWinSound);
        // TweenLite.delayedCall(15, () => this.fadeMediumAndLargeWinSound(), []);
    }

    public static fadeMediumAndLargeWinSound(): void {
        Logger.logDev("mediumAndLargeWin fadeMediumAndLargeWinSound");
        this.soundPlayer.fadeTrack({
            name: RomanEmpireSoundConfig.instance.MEDIUM_AND_LARGE_WIN,
            to: 0,
            duration: 10000
        });
    }

    public static reset(): void {
        SoundManager.fadeSound(RomanEmpireSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 300, 1);
        SoundManager.fadeSound(RomanEmpireSoundConfig.instance.MEDIUM_AND_LARGE_WIN, 300, 0);
    }

    public static playFSIntro() {
        Logger.logDev("ReSpinSound playFSIntro");
        SoundManager.stopSound(RomanEmpireSoundConfig.instance.FS_INTRO);
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_INTRO, 0, 1);
    }

    public static playFSBackgroundMusic() {
        Logger.logDev("ReSpinSound playFSBackgroundMusic");
        SoundManager.stopSound(RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS);
        SoundManager.playSound(RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS, 0, 1);
    }

    public static playFSMusicIntro() {
        Logger.logDev("ReSpinSound playFSMusicIntro");
        SoundManager.stopSound(RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS_INTRO);
        SoundManager.playSound(RomanEmpireSoundConfig.instance.BACKGROUND_MUSIC_FS_INTRO, 0, 1);
    }

    public static playFSStartSound() {
        Logger.logDev("ReSpinSound playFSStartSound");
        SoundManager.stopSound(RomanEmpireSoundConfig.instance.FS_START);
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_START, 0, 1);
    }

    public static playFSScatterToScatter() {
        Logger.logDev("ReSpinSound playFSScatterToScatter");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_SCATTER_TO_SCATTER);
    }

    public static playFSScatterMoves() {
        Logger.logDev("ReSpinSound playFSScatterMoves");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_SCATTER_MOVES);
    }

    public static playFSScatterFire() {
        Logger.logDev("ReSpinSound playFSScatterFire");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_SCATTER_FIRE);
    }

    public static playFSScatterExplodeMultiplier() {
        Logger.logDev("ReSpinSound playFSScatterExplodeMultiplier");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_SCATTER_EXPLODE_MULTIPLIER);
    }

    public static playFSScatterShootFireBall() {
        Logger.logDev("ReSpinSound playFSScatterShootFireBall");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_SCATTER_SHOOT_FIREBALL);
    }

    public static playFSScatterMultiplierUpdate() {
        Logger.logDev("ReSpinSound playFSScatterMultiplierUpdate");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_SCATTER_MULTIPLIER_UPDATE);
    }

    public static playFSOutro() {
        Logger.logDev("ReSpinSound playFSOutro");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_OUTRO);
    }

    public static playFSOutroContinue() {
        Logger.logDev("ReSpinSound playFSOutroContinue");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_OUTRO_CONTINUE_BTN);
    }

    public static playAnticipationFail() {
        Logger.logDev("ReSpinSound playAnticipationFail");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.SCATTER_ANTICIPATION_FAILS);
    }

    public static playAnticipationSuccess() {
        Logger.logDev("ReSpinSound playAnticipationSuccess");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.SCATTER_ANTICIPATION_ENDS);
    }
    public static playFSWinLine() {
        Logger.logDev("ReSpinSound playFSWinLine");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_WIN_LINE);
    }
    public static playLeopard() {
        Logger.logDev("initialWinSound playLeopard");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.ANIMAL_LEOPARD);
    }
    public static playSnake() {
        Logger.logDev("initialWinSound playSnake");
        SoundManager.playSound(RomanEmpireSoundConfig.instance.ANIMAL_SNAKE);
    }
}